<template>
  <div class="yh-page">
    <el-card>
      <el-row>
        <el-col :span="14" class="pt-3">
          <el-form :rules="rules" ref="dataForm" :model="formData" label-position="right" label-width="160px">

            <el-form-item prop="username" label="账号">
              <span class="bg-success text-white font-weight-bold rounded px-2 py-1">
                {{ formData.username }}
              </span>
            </el-form-item>
            <el-form-item prop="first_name" label="用户名">
              <el-input v-model="formData.first_name" autoComplete="on"></el-input>
            </el-form-item>
            <el-form-item prop="gender" label="性别">
              <el-radio v-model="formData.gender" :label="0">男</el-radio>
              <el-radio v-model="formData.gender" :label="1">女</el-radio>
            </el-form-item>
            <el-form-item prop="email" label="邮箱">
              <el-input v-model="formData.email" autoComplete="on"></el-input>
            </el-form-item>
            <el-form-item prop="email_signature" label="邮件签名">
              <el-input type="textarea" v-model="formData.email_signature" :autosize="{ minRows: 4, maxRows: 8 }"
                placeholder="请输入邮件签名"></el-input>
            </el-form-item>



            <el-form-item type="password" prop="emailPassword" label="邮箱密码">
              <el-input name="password" :type="passwordType" v-model="formData.emailPassword" autoComplete="on"
                placeholder="请输入邮箱密码" show-password />
            </el-form-item>
            <!--el-form-item prop = "date_joined" label = "创建时间">
              {{ formData.date_joined | formatDate }}
            </el-form-item>
            <el-form-item prop = "last_login" label = "上次登录时间">
              {{ formData.last_login ? formData.last_login : '无' | formatDate }}
            </el-form-item -->
            <el-form-item prop="roles" label="角色">
              {{ formData.roles !== undefined && formData.roles.length > 0 ? formData.roles.join(' ') : '无' }}
            </el-form-item>
            <el-form-item prop="roles" label="权限">
              {{ formData.permissions !== undefined && formData.permissions.length > 0 ? formData.permissions.join(' ')
                  : '无'
              }}
            </el-form-item>
            <el-form-item prop="avatar" label="用户头像">
              <el-upload class="avatar-uploader" action="" :http-request="handleUploadFile"
                :show-file-list="false" :before-upload="beforeAvatarUpload" >
                <img v-if="formData.avatar" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="loginPassword">修改登录密码</el-checkbox>
            </el-form-item>
          </el-form>

          <el-form v-if="loginPassword == true" :rules="loginPassword ? passwordRules : []" ref="passwordForm"
            :model="formData" label-position="right" label-width="160px">
            <el-form-item prop="oldPassword" label="旧密码">
              <el-input name="password" :type="passwordType" v-model="formData.oldPassword" autoComplete="on"
                placeholder="请输入旧密码" show-password />
              <!--span class="show-pwd" @mousedown="passwordType = ''" @mouseup="passwordType = 'password'">
                <svg-icon icon-class="eye"/>
              </span -->
            </el-form-item>
            <el-form-item prop="newPassword" label="新密码">
              <el-input name="password" :type="passwordType" v-model="formData.newPassword" autoComplete="on"
                placeholder="请输入新密码" show-password />

            </el-form-item>
            <el-form-item type="password" prop="confirmPassword" label="确认密码">
              <el-input name="password" :type="passwordType" v-model="formData.confirmPassword" autoComplete="on"
                placeholder="请再次输入新密码" show-password />


              <!--span class="show-pwd" @mousedown="passwordType = ''" @mouseup="passwordType = 'password'">
                <svg-icon icon-class="eye"/>
              </span-->
            </el-form-item>

          </el-form>
        </el-col>
      </el-row>
      <div class="border-top py-3" style="padding-left: 160px">
        <el-button size="small" @click="handleReturn">返回</el-button>
        <el-button type="primary" size="small" @click="updateData">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>


<script>
import { fetchUser } from '@/api/user'
import { validateUsername, validatePassword, validateEmail } from '@/utils/validate'
import { updateUser, changeUserPassword } from '@/api/user'
import { goBack } from '@/utils'
import { error_message } from '@/utils/misc'
import {getToken} from "@/utils/auth"
import {uploadAvatar} from "@/api/upload"


export default {
  name: 'personal',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value == undefined || value == null || value.length < 6) {
        callback(new Error('密码长度必须大于等于6位'))
      }
      else if (value != this.formData.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      imageUrl: '',
      formData: {},
      loginPassword: false,
      passwordType: 'password',
      rules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        first_name: [{ required: true, message: '请填写用户名', trigger: 'blur' }],
        gender: [{ required: true, trigger: 'blur', message: '请选择性别' }],
        email: [{ required: true, trigger: 'blur', validator: validateEmail }],
      },
      passwordRules: {
        oldPassword: [{ required: true, trigger: 'blur', validator: validatePassword }],
        newPassword: [{ required: true, trigger: 'blur', validator: validatePassword }],
        confirmPassword: [{ required: true, trigger: 'blur', validator: validateConfirmPassword }]
      }
    }
  },

    computed: {
      headers() {
        return {
          Authorization: "Token " + getToken()
        }
      }
    },

  methods: {

   handleUploadFile(param) {
      let file = param.file
      const form = new FormData()
      form.append('file',file)
      uploadAvatar(form).then(res=> {
        this.handleAvatarSuccess(res)
      })
    },

    handleAvatarSuccess(res) {
      this.formData.avatar = res.url
      this.imageUrl = process.env.VUE_APP_DOMAIN + this.formData.avatar
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },

    handleReturn() {
      goBack(this.$router)
    },
    resetPassword() {
      this.formData.emailPassword = ''
      this.formData.oldPassword = ''
      this.formData.newPassword = ''
      this.formData.confirmPassword = ''
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          updateUser(this.formData.id, this.formData)
            .then(() => {
              if (this.loginPassword) {
                this.$refs.passwordForm.validate(valid => {
                  if (valid) {
                    changeUserPassword(this.formData.id, this.formData)
                      .then(() => {
                        this.$message.success('修改用户信息成功')
                        this.resetPassword()
                      })
                      .catch(error => {
                        error_message(error)
                      })
                  }
                })
              }
              else
                this.$message.success('修改用户信息成功')
            })
            .catch(error => {
              this.$error_message(error)
            })
        }
      })
    }
  },
  created() {
    fetchUser(this.$store.state.user.user)
      .then(res => {
        this.formData = Object.assign({}, res)
        this.imageUrl = process.env.VUE_APP_DOMAIN + this.formData.avatar
        this.$refs['dataForm'].clearValidate()
      })
      .catch(error => {
        this.$message.error(error)
      })
  }
}
</script>
